import { Injectable, NgZone } from '@angular/core';
import {
    Http,
    RequestOptionsArgs,
    RequestOptions,
    ConnectionBackend,
    Request,
    Response,
    XHRBackend
} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { IApplicationState } from '../stateManagement/states/ApplicationState';
import { DisableBusyFlag, EnableBusyFlag } from '../stateManagement/actions/containers/application';
import { environment } from '../../environments/environment';
import * as _ from 'lodash';
import { BlockUIService } from 'ng-block-ui';

@Injectable()
export class CustomHttp extends Http {
  private activeCalls: number;
  private store: Store<IApplicationState>;
  private blockUI: BlockUIService;
  private zone: NgZone;

  constructor(
    backend: ConnectionBackend,
    defaultOptions: RequestOptions,
    store: Store<IApplicationState>,
    zone: NgZone,
    blockUI: BlockUIService
  ) {
    super(backend, defaultOptions);
    this.store = store;
    this.activeCalls = 0;
    this.blockUI = blockUI;
    this.zone = zone;
  }

  // private functions
  private httpCallRequested(): void {
    if (this.activeCalls === 0) {
      if (!this.blockUI.isRunning())
        this.store.dispatch(new EnableBusyFlag({}));
    }
    this.activeCalls++;
  }

  private httpCallReady(): void {
    this.activeCalls--;
    if (this.activeCalls === 0) {
      //this.zone.run(() => this.store.dispatch(new DisableBusyFlag({})));
      this.store.dispatch(new DisableBusyFlag({}));
    }
  }

  private getFullUrl(url: string): string {
    return environment.API_ENDPOINT + url;
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
      this.httpCallRequested();
      return super.request(url, options).finally(
          () => {
              this.httpCallReady();
          }
      );
  };

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    this.httpCallRequested();
    let _url = this.getFullUrl(url);
    if (_.startsWith(url, 'http') || _.startsWith(url, 'https')) {
      _url = url;
    }
    return super.get(_url, options).finally(
        () => {
            this.httpCallReady();
        }
    );
  }

  post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    this.httpCallRequested();
    let _url = this.getFullUrl(url);
    let _body = _.cloneDeep(body);
    if (_.size(body) && _.has(body, 'absoluteUrl')) {
      _url = url;
      _body = _.omit(_body, 'absoluteUrl');
    }

    return super.post(_url, _body, options).finally(
        () => {
            this.httpCallReady();
        }
    );
  };

  put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return super.put(this.getFullUrl(url), body, options);
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return super.delete(this.getFullUrl(url), options);
  }

  patch(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return super.patch(this.getFullUrl(url), body, options);
  }

  head(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return super.head(this.getFullUrl(url), options);
  }

  /**
   * Performs a request with `options` http method.
   */
  options(url: string, options?: RequestOptionsArgs): Observable<Response> {
    this.httpCallRequested();
    return super.options(this.getFullUrl(url), options).finally(
        () => {
            this.httpCallReady();
        }
    );
  }

}

export function customHttpFactory(backend: XHRBackend,
                                defaultOptions: RequestOptions,
                                store: Store<IApplicationState>,
                                zone: NgZone,
                                blockUI: BlockUIService) {
  return new CustomHttp(backend, defaultOptions, store, zone, blockUI);
}



// WEBPACK FOOTER //
// ./src/app/application/customHttp.service.ts